import { QuickPostModalBody } from "@circle-react/components/QuickPostV3/QuickPostModalBody";

import { AdvancedSection } from "./AdvancedSection";
import { DisplayFeaturingSection } from "./DisplayFeaturingSection";
import { EngagementSection } from "./EngagementSection";
import { SettingsHeader } from "./Header";
import { PublishingSection } from "./PublishingSection";
import { SharingSection } from "./SharingSection";

export const QuickPostV3Settings = () => (
  <div className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden">
    <SettingsHeader />
    <div className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden">
      <QuickPostModalBody data-testid="quick-post-v3-settings">
        <div className="mx-auto flex w-full max-w-3xl flex-col gap-4 pt-2">
          <PublishingSection />
          <EngagementSection />
          <DisplayFeaturingSection />
          <SharingSection />
          <AdvancedSection />
        </div>
      </QuickPostModalBody>
    </div>
  </div>
);
